import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { Code, P, Tabs } from '@decisiv/ui-components';
import spacing from '@decisiv/design-tokens/lib/spacing';
import rem from 'polished/lib/helpers/rem';
import TextField from '@decisiv/ui-components/lib/components/TextField';

export const IntegrationDetailPageHeaderBreadcrumbs = styled.div`
  padding: 0.313rem 0 0.313rem 1.25rem;
`;

export const IntegrationDetailSection = styled(Flex)`
  gap: 0.313rem;
  width: 100%;
  background: ${toColorString(color.base.snowWhite)};
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

export const IntegrationDetailTabs = styled(Tabs)`
  padding: 0;
  width: 100%;

  & > div:nth-child(1) {
    padding: 0 1.25rem;
    background: ${toColorString(color.base.snowWhite)};
  }
`;

export const IntegrationSettingsContainer = styled(Flex)`
  gap: 1.25rem;
`;

export const IntegrationWrapper = styled(Flex)`
  padding: 1.55rem;
  flex-direction: column;
`;

export const IntegrationSettingsInfo = styled(Flex)`
  width: 283px;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  background: var(--if-surface-2);
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }
`;

export const ArchiveBox = styled(Flex)`
  background: ${toColorString(color.base.snowWhite)};
  margin-top: 1.25rem;
  width: 283px;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  background: var(--if-surface-2);
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }
`;

export const AudienceInfo = styled(Flex)`
  width: 283px;
  background: ${toColorString(color.base.snowWhite)};
  margin-top: 1.25rem;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }

  p {
    color: var(--if-ink-2);
    font-size: 12px;
    margin: 0;
  }
`;

export const IntegrationSettingsForm = styled.form`
  display: flex;
  position: relative;
  width: 100%;
  padding: 1.25rem 0.8rem;
  flex-direction: column;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid var(--if-border);
  border-radius: 4px;
`;

export const IntegrationDetailLocations = styled(Flex)`
  height: auto;
  margin: 1.25rem;
  background-color: var(--if-surface-1);
  border: 1px solid var(--if-border);
  border-radius: 4px;
`;

export const IntegrationDetailDefaultNoLocationsWrapper = styled(Flex)`
  width: 40%;
  margin: auto;
`;

export const IntegrationDetailDefaultNoLocationsTitle = styled(Flex)`
  text-align: center;
  color: ${toColorString(color.base.charcoal)};
`;

export const IntegrationDetailDefaultNoLocationsIconWrapper = styled(Flex)`
  background: ${toColorString(color.visualInterest.licoriceMousse.medium)};
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 3.125rem;
  padding: 0.875rem;
`;

export const CenteredContainer = styled(Flex)`
  width: 100%;
`;

export const FilterTextField = styled(TextField)`
  width: ${rem(spacing.base * 32)};
`;

export const HelpInputMessage = styled(Flex)`
  margin-top: ${rem(spacing.base * 0.2)};
  margin-bottom: ${rem(spacing.base * 2)};
  color: var(--if-ink-2);
`;

export const HelpInputText = styled(P)`
  margin-left: ${rem(spacing.base * 0.5)};
`;

export const NoResultDescription = styled(P)`
  width: ${rem(spacing.base * 40)};
  text-align: center;
`;

export const CommandsContainer = styled(Flex)`
  flex-direction: column;
  gap: ${rem(spacing.base * 2)};
  padding: ${rem(spacing.base * 2)};
  width: 100%;
`;

export const CommandCard = styled(Flex)`
  flex-direction: column;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.opacity.charcoal15)};
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
`;

export const CommandCardHeader = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base)};
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)};
  border-bottom: 1px solid ${toColorString(color.opacity.charcoal15)};
  background: var(--if-surface-2);
  flex-wrap: wrap;
`;

export const CommandCardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${toColorString(color.base.charcoal)};
  margin: 0;
`;

export const StateBadge = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${toColorString(color.base.alaskanHusky)};
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.opacity.charcoal15)};
  border-radius: 12px;
  padding: 2px 10px;
`;

export const CommandCardBody = styled.div`
  width: 100%;
  height: 600px;
  position: relative;
`;

export const LegendContainer = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 2)};
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)};
  flex-wrap: wrap;
`;

export const LegendItem = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
  font-size: 11px;
  color: ${toColorString(color.base.alaskanHusky)};
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: ${({ dotColor }) => dotColor};
  border: 1px solid var(--if-border);
  flex-shrink: 0;
`;

export const EmptyStateContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${rem(spacing.base * 6)} ${rem(spacing.base * 2)};
  width: 100%;
  gap: ${rem(spacing.base)};
`;

export const EmptyStateText = styled(P)`
  color: ${toColorString(color.base.alaskanHusky)};
  text-align: center;
  font-size: 14px;
`;

export const Separator = styled(Flex)`
  width: 2px;
  height: ${rem(spacing.base * 3.1)};
  margin-right: ${rem(spacing.base * 2)};
  background: ${toColorString(color.opacity.charcoal15)};
`;

export const DeveloperCodeView = styled(Code).attrs({ className: 'if-code' })`
  background: var(--if-code-bg);
  color: var(--if-code-fg);
  margin: 0;
  padding: 20px;
  letter-spacing: -0.8px;
  overflow: auto;
  width: 100%;
  height: 800px;

  &::selection,
  & *::selection {
    background: var(--if-focus);
    color: var(--if-code-fg);
  }
`;

export const DeveloperCodeViewManualInvocation = styled(DeveloperCodeView)`
  min-height: 640px;
`;

export const TextAreaDeveloperCodeView = styled.textarea.attrs({
  className: 'if-code',
})`
  background: var(--if-code-bg);
  color: var(--if-code-fg);
  margin: 0;
  padding: 20px;
  letter-spacing: -0.8px;
  overflow: auto;
  width: 100%;
  height: 800px;
  border-style: none;
  border-color: Transparent;
  outline: none;
  font-size: 16px;
`;

export const CircuitBreakerAlertText = styled(P)`
  color: indianred;
  font-size: 14px;
  margin-left: 0.6rem;
`;
export const CustomIntegrationSettingsInfo = styled(Flex)`
  width: 283px;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid var(--if-border);
  border-radius: 4px;
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }
`;

export const CustomAudienceInfo = styled(Flex)`
  width: 283px;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid var(--if-border);
  border-radius: 4px;
  margin-top: 1.25rem;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }

  p {
    color: var(--if-ink-2);
    font-size: 12px;
    margin: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
`;

export const CustomArchiveBox = styled(Flex)`
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid var(--if-border);
  border-radius: 4px;
  margin-top: 1.25rem;
  width: 283px;
  height: auto;
  padding: 1.25rem;
  gap: 0.5rem;
  align-self: start;
  align-items: start;
  flex-direction: column;

  h3 {
    word-wrap: anywhere;
  }
`;

/* ── Execution Overlay ── */

const OVERLAY_BORDER_COLORS = {
  RUNNING: toColorString(color.status.information.medium),
  SUCCEEDED: toColorString(color.status.success.medium),
  FAILED: toColorString(color.status.danger.medium),
};

export const OverlayBar = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 1.5)};
  padding: ${rem(spacing.base)} ${rem(spacing.base * 2)};
  background: ${toColorString(color.base.snowWhite)};
  border-bottom: 1px solid ${toColorString(color.opacity.charcoal15)};
  border-left: 3px solid
    ${({ executionStatus }) =>
      OVERLAY_BORDER_COLORS[executionStatus] ||
      toColorString(color.opacity.charcoal15)};
  flex-wrap: wrap;
`;

export const OverlaySection = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
`;

export const OverlayLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${toColorString(color.base.alaskanHusky)};
`;

export const OverlayValue = styled.span`
  font-size: 12px;
  color: ${toColorString(color.base.charcoal)};
  font-family: monospace;
`;

export const ElapsedTime = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${toColorString(color.status.information.dark)};
  font-family: monospace;
`;
